// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_32RoM","label":"index_label_30ZQh"};